import { gql } from "@apollo/client";

export const DeleteMobileDevice = gql`
  mutation DeleteMobileDevice(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $deviceID: ID!
  ) {
    DeleteMobileDevice(
      token: $token
      customerID: $customerID
      user_details: $user_details
      deviceID: $deviceID
    )
  }
`;
